<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
    <mat-dialog-content>
        <mat-tab-group animationDuration="1000ms">
            <!-- Datos Personales -->
            <mat-tab label="Código Equipo">
                <div class="container-fluid mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nombre del Equipo</mat-label>
                                <input matInput formControlName="nombreEquipo" placeholder="Nombre del Equipo"
                                    (blur)="form.controls['nombreEquipo'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="90">
                                <mat-error *ngIf="isValidField('nombreEquipo')">
                                    {{ getFieldError('nombreEquipo') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Proc. Cali.</mat-label>
                                <input matInput formControlName="claveEquipo" placeholder="Proc. Cali."
                                    (blur)="form.controls['claveEquipo'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="13">
                                <mat-error *ngIf="isValidField('claveEquipo')">
                                    {{ getFieldError('claveEquipo') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Procedimiento de Calibración">
                <div class="container-fluid mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Fecha de Actualización</mat-label>
                                <input matInput type="date" formControlName="fechaAutorizacion" placeholder="Fecha de Actualización">
                                <mat-error *ngIf="isValidField('fechaAutorizacion')">{{ getFieldError('fechaAutorizacion') }}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>Realizo</mat-label>
                              <input
                                type="text"
                                matInput
                                [formControl]="colaboradorControl"
                                [matAutocomplete]="auto"
                                placeholder="Escribe para buscar..."
                                (focus)="abrirAutocomplete()"
                                (blur)="colaboradorControl.markAsTouched()"
                                uppercase
                              />
                              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="seleccionarColaborador($event)">
                                <mat-option *ngFor="let colaborador of filteredColaboradores$ | async" [value]="colaborador">
                                  {{ colaborador.idColaborador }} - {{ colaborador.nombre }} {{ colaborador.apellidoPaterno }} {{ colaborador.apellidoMaterno }}
                                </mat-option>
                              </mat-autocomplete>
                              <mat-icon matSuffix>arrow_drop_down</mat-icon>
                              <mat-error *ngIf="colaboradorControl.invalid && colaboradorControl.touched">
                                Este campo es obligatorio
                              </mat-error>
                            </mat-form-field>
                          </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Procedimiento</mat-label>
                                <textarea matInput formControlName="procedimiento" placeholder="Procedimiento" 
                                  (blur)="form.controls['procedimiento'].markAsTouched()" 
                                  uppercase maxlength="250"></textarea>
                                <mat-error *ngIf="isValidField('procedimiento')">
                                  {{ getFieldError('procedimiento') }}
                                </mat-error>
                              </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton">
            <i class="fa fa-save"></i> Guardar
        </button>
        <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
            <i class="fa fa-remove fa-solid"></i> Cancelar
        </button>
    </mat-dialog-actions>
</form>